class RolesHelper {
  isAdmin = (role: string) => role === 'admin';
  isReseller = (role: string) => role === 'reseller';
  isUser = (role: string) => role === 'user';
}

export default new RolesHelper();
